import React from 'react'
import styled, { FlattenSimpleInterpolation } from 'styled-components'
import { black } from 'uiComponents/constants/colors'
import {
  mediaDesktopAndUp,
  mediaTabletAndDown,
} from 'uiComponents/constants/customMedia'
import { fsXS, fsXXL, fwBold } from 'uiComponents/constants/typography'

interface IHeadlineProps {
  title: string | null
  text: string | null
  customStyles?: {
    headline?: FlattenSimpleInterpolation
    text?: FlattenSimpleInterpolation
  }
}

type CustomStyleProps = {
  customStyles?: FlattenSimpleInterpolation
}

const HeadlineWrapper = styled.div<CustomStyleProps>`
  font-size: ${fsXXL}px;
  margin-bottom: 10px;
  text-align: center;
  color: ${black};
  ${fwBold}
  @media ${mediaTabletAndDown} {
    margin-top: 30px;
  }
  @media ${mediaDesktopAndUp} {
    margin-top: 60px;
  }

  ${({ customStyles }) => customStyles && customStyles}
`

const TextWrapper = styled.div<CustomStyleProps>`
  font-size: ${fsXS}px;
  text-align: center;
  color: ${black};
  @media ${mediaTabletAndDown} {
    margin-bottom: 30px;
  }
  @media ${mediaDesktopAndUp} {
    margin-bottom: 60px;
  }

  ${({ customStyles }) => customStyles && customStyles}
`

const Headline: React.FC<IHeadlineProps> = ({ title, text, customStyles }) => {
  return (
    <div>
      <HeadlineWrapper customStyles={customStyles?.headline}>
        {title}
      </HeadlineWrapper>
      <TextWrapper customStyles={customStyles?.text}>{text}</TextWrapper>
    </div>
  )
}

export default Headline
